(function() {
  'use strict';

  function updateMinicartFromHTML(minicartHTML) {
    var minicart = document.getElementById('js_cart_popup');
    if (!minicart) return;
    var parsed = new DOMParser().parseFromString(minicartHTML, 'text/html');
    var inner = parsed.querySelector('.wrap-mini-cart');
    if (!inner) inner = parsed.body;
    minicart.innerHTML = inner ? inner.innerHTML : minicartHTML;

    // Actualizeaza contorul din header
    var jsonDataEl = minicart.querySelector('#json-data-cart');
    if (jsonDataEl) {
      try {
        var cartData = JSON.parse(jsonDataEl.textContent);
        // Count
        document.querySelectorAll('.js-cart-count').forEach(function(el) {
          el.textContent = cartData.item_count;
        });
        document.querySelectorAll('[data-js-cart-count]').forEach(function(el) {
          el.setAttribute('data-js-cart-count', cartData.item_count);
          el.textContent = cartData.item_count;
        });
      } catch(e) {}
    }

    // Notifica tema ca DOM-ul s-a schimbat
    document.body.dispatchEvent(new Event('contentUpdated'));
  }

  function openCartSidebar() {
    var minicart = document.getElementById('js_cart_popup');
    if (minicart && !minicart.classList.contains('act_opened')) {
      var sideBtn = document.querySelector('[data-id="#js_cart_popup"]');
      if (sideBtn) sideBtn.click();
    }
  }

  document.addEventListener('click', function(e) {
    var btn = e.target.closest('.js_add_to_cart_button');
    if (!btn) return;
    if (btn.classList.contains('ajax_loading')) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    var pid = btn.dataset.pid;
    if (!pid) return;

    btn.classList.add('ajax_loading');
    var originalText = btn.querySelector('.uiverse-text, .text');
    var originalHTML = originalText ? originalText.innerHTML : '';

    var fd = new FormData();
    fd.append('id', pid);
    fd.append('quantity', '1');
    fd.append('sections', 'minicart');
    fd.append('sections_url', window.location.pathname);

    // Cantitate din product-item daca exista
    var productItem = btn.closest('.product-item');
    if (productItem) {
      var qtyInput = productItem.querySelector('[name="quantity"]');
      if (qtyInput) fd.set('quantity', qtyInput.value);
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Accept': 'application/javascript',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: fd
    })
    .then(function(r) { return r.json(); })
    .then(function(response) {
      btn.classList.remove('ajax_loading');

      if (response.status) {
        // FAIL - sold out
        if (response.description) alert(response.description);
        btn.setAttribute('disabled', 'disabled');
        btn.setAttribute('data-button-status', 'sold-out');
        btn.classList.add('sold_out');
        if (originalText) originalText.textContent = 'Sold Out';
        return;
      }

      // SUCCESS
      btn.classList.add('added');
      if (originalText) originalText.textContent = 'Adăugat';

      setTimeout(function() {
        btn.classList.remove('added');
        if (originalText) originalText.innerHTML = originalHTML;
      }, 1200);

      // Actualizeaza minicart
      if (response.sections && response.sections.minicart) {
        updateMinicartFromHTML(response.sections.minicart);
      }

      // Deschide sidebar
      setTimeout(function() {
        openCartSidebar();
      }, 80);

      // Notifica alte scripturi
      document.body.dispatchEvent(new CustomEvent('ajax:addToCart', {
        detail: { response: response }
      }));
    })
    .catch(function(err) {
      console.log('Cart error:', err);
      btn.classList.remove('ajax_loading');
    });

  }, true); // true = capture phase, ruleaza primul
  // Sterge tot cosul
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('.clear-cart');
    if (!btn) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    fetch('/cart/clear.js', {
      method: 'POST',
      headers: {'Content-Type': 'application/json'}
    }).then(function() {
      location.reload();
    });
  }, true);
})();